export const inflectImageCount: Record<number, string> = {
	1: "první",
	2: "druhý",
	3: "třetí",
	4: "čtvrtý",
	5: "pátý",
	6: "šestý",
	7: "sedmý",
	8: "osmý",
	9: "devátý",
	10: "desátý",
};
